/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Finals_Unresolved_TiesInputs */



/**
* | output |
* | --- |
* | "Resolve all ties in top 5 before starting finals" |
*
* @param {Err_Tournament_Finals_Unresolved_TiesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_finals_unresolved_ties = /** @type {((inputs?: Err_Tournament_Finals_Unresolved_TiesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Finals_Unresolved_TiesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résolvez toutes les égalités dans le top 5 avant de lancer la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resuelva todos los empates en el top 5 antes de iniciar las finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Resolva todos os empates no top 5 antes de iniciar as finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risolvi tutti i pareggi nel top 5 prima di avviare le finali")
	return /** @type {LocalizedString} */ ("Resolve all ties in top 5 before starting finals")
});